import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ApiService, IEngineer } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export class DcaLicenseService {
  constructor(private api: ApiService) {}

  public getLdpLicense(
    licenseNumber: string,
    licenseType: string
  ): Observable<IEngineer> {
    return this.api
      .get(
        `/LicensesValidation/ValidateEngineerLicense?licenseType=${licenseType}&licenseNumber=${licenseNumber}`
      )
      .pipe(map(engg => engg as IEngineer));
  }
}
